/**
 * Extracts organization slug from the current hostname.
 * Assumes a structure like: [slug].[domain].[ext]
 * If on localhost, it can be tested with [slug].localhost
 */
export const getOrganizationSlug = () => {
    const hostname = window.location.hostname;
    
    // Skip IP addresses and plain localhost
    if (/^[0-9.]+$/.test(hostname) || hostname === 'localhost') {
        return null;
    }

    const parts = hostname.split('.');
    
    // If we have at least 3 parts (e.g., org.example.com), the first part is the slug
    // For localhost testing: org.localhost -> 2 parts
    if (parts.length >= 2) {
        // Check if we're on localhost
        if (hostname.endsWith('.localhost')) {
            return parts[0];
        }
        
        // Skip default firebase domains if it's strictly the root
        if (hostname === 'quadcores-properties-uat.web.app' || hostname === 'quadcores-properties.web.app') {
            return null;
        }

        // For production domains with 3+ parts (ignoring .web.app which is 2 parts itself)
        if (hostname.endsWith('.web.app')) {
            // e.g. tenant.quadcores-properties-uat.web.app -> 4 parts. The slug is parts[0]
            if (parts.length > 3) {
                return parts[0];
            }
            return null; // Just the root domain
        } else if (parts.length >= 3) {
            return parts[0];
        }
    }

    return null;
};
